exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table td svg[data-v-21ce8d26]{vertical-align:middle}", ""]);

// exports
